import React, { useState } from 'react';
import { View, Text } from 'react-native'
import { DateTime } from 'luxon';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from './index';
import DateInput from 'app/src/elements/DateInput';

const SoldByPaddleServiceReport = () => {
  const [startOn, setStartOn] = useState(
    DateTime.now().startOf('year').toISODate()
  );

  const [endOn, setEndOn] = useState(DateTime.now().toISODate());

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'sold-by-paddle-service-report',
      params: { 'start-on': startOn, 'end-on': endOn }
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Sold To Buyers Per Paddle Service</Text>
      <Text style={styles.label}>Start On (sale date):</Text>
      <DateInput
        style={styles.select}
        onChange={e => setStartOn(e.target.value)}
        value={startOn || ''}
      />
      <Text style={styles.label}>End On (sale date):</Text>
      <DateInput
        style={styles.select}
        onChange={e => setEndOn(e.target.value)}
        value={endOn || ''}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default SoldByPaddleServiceReport;
